import React from 'react';
import axios from 'axios';
import './index.css';
import ProjectDescHead from '../../component/ProjectDescHead';
import { Spinner } from 'react-bootstrap';

class ProjectDescContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      desc: {
        titleApp: '',
        desc: '',
        team: '',
        poster: '',
        site: '',
        category: '',
      },
      isLoading: true,
    };
  }

  componentDidMount() {
    let id = this.props.match.params.id;
    axios({
      method: 'get',
      url: `https://eclipsesp-app.herokuapp.com/projek/${id}`,
    })
      .then((res) => {
        let desc = res.data;
        this.setState({
          desc: {
            titleApp: desc.data.nama_aplikasi,
            desc: desc.data.deskripsi_aplikasi,
            team: desc.data.team,
            poster: desc.data.poster,
            site: desc.data.site,
            category: desc.data.category.name,
          },
          isLoading: false,
        });
      })
      .catch((err) => console.log(err));
  }

  render() {
    return (
      <div className="detail-container">
        <ProjectDescHead
          name={this.state.desc.titleApp}
          category={this.state.desc.category}
        />
        {this.state.isLoading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <div className="container py-4">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex flex-column">
                  <div className="mt-4 sub-title-desc">Description.</div>
                  <p className="text-desc">{this.state.desc.desc}</p>
                  <div className="mt-4 sub-title-desc">Infographics.</div>
                  <div className="d-flex justify-content-center">
                    <img
                      className="poster"
                      src={
                        'https://eclipsesp-app.herokuapp.com/resource/storage/image/poster/' +
                        this.state.desc.poster
                      }
                      alt="Android Phone"
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mt-4 sub-title-desc">Team.</div>
                      <p className="text-desc">{this.state.desc.team}</p>
                      <p className="">Teknik Informatika Unpad 2018</p>
                    </div>
                    <div className="col-md-6">
                      <div className="mt-4 sub-title-desc">Product.</div>
                      <a className="text-desc" href={this.state.desc.site}>
                        {this.state.desc.site}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ProjectDescContainer;
